import { PageViewProperties, SearchProperties, UserEngagementProperties } from './useAnalytics.types'

declare global {
  interface Window {
    heap: any
  }
}

export function heapIdentify({ email, role }) {
  try {
    // * email is required for identification.
    if (window.heap && email.length > 0) {
      window.heap.identify(email)
      window.heap.addUserProperties({ email, role })
    }
  } catch (error) {
    /* eslint-disable no-console */
    console.error(error, 'Unable to identify user for Heap.')
  }
}

export function heapTrack(
  eventName: string,
  eventProperties: PageViewProperties | UserEngagementProperties | SearchProperties,
): void {
  try {
    if (window && window.heap) {
      const payload = {
        environment: process.env.APP_ENV || 'development',
        ...eventProperties,
      }

      window.heap.track(eventName, payload)
    } else {
      // * if heap isn't loaded yet, retry
      setTimeout(() => heapTrack(eventName, eventProperties), 1000)
    }
  } catch (error) {
    /* eslint-disable no-console */
    console.log(error, 'Unable to track event for Heap.')
  }
}
